import * as yup from 'yup';

export const CartaCorrecaoCancelarNotaFiscalSchema = yup.object().shape({
  justificativa: yup
    .string()
    .required('Campo Obrigatório!')
    .min(15, 'O Campo deve ter no mínimo 15 caracteres'),
});